/*
 * @Author: 刘枫 
 * @Date: 2021-05-27 17:26:23 
 * @Description: 报修信息
 * @Last Modified by:   liufeng 
 * @Last Modified time: 2021-05-27 17:26:23 
 */

<template>
  <div class="business-progress">
    <van-nav-bar left-text="返回" :title="$route.meta.title" @click-left="$comm.onClickLeft" left-arrow v-show="$comm.titleShow()" fixed>
      <template #left>
        <span class="iconfont iconshang comm-rotate-270"></span>
        <span class="comm-return">返回</span>
      </template>
    </van-nav-bar>
    <div class="comm-topbar-height" v-show="$comm.titleShow()"></div>

    <van-list :finished="false" finished-text="没有更多了" class="course-more__content" :immediate-check="false">
      <div class="page-container" v-for="(li, i) in list" :key="i">
        <topicList :type="type" :obj="li"></topicList>
      </div>
      <div v-show="list.length===0" style="text-align:center;">
        <img style="width:200px;" :src="require('@/assets/images/no-data.png')">
      </div>
    </van-list>

    <div class="comm-homebar-height"></div>
    <home-bar></home-bar>
  </div>
</template>

<script>
import HomeBar from '@/components/HomeBar.vue'
import topicList from '@/components/topicList.vue'
export default {
  name: 'BusinessProgress',
  components: {
    HomeBar,
    topicList
  },
  data() {
    return {
      active: 0,
      typeList: [],
      typeCode: '',
      typeName: '',
      currentTabComponent: 'OnlineProgress',
      refreshFlag: null,
      list: [],
      type: 1
    }
  },
  mounted() {
    this.getList()
  },
  activated() {
    // 前进刷新，后退缓存处理
    if (this.$route.meta.isUseCache) {
      this.$route.meta.isUseCache = false
    } else {
      if (this.$route.query.active) {
        this.active = Number(this.$route.query.active)
      }
      if (this.active === 0) {
        this.currentTabComponent = 'OnlineProgress'
      }
    }
  },
  methods: {
    topChange(currentTabComponent) {
      this.currentTabComponent = currentTabComponent
    },
    getList() {
      this.$http.post(this.$api.servicelist, { busstype: 12 }).then(res => {
        if (res.code === '000') {
          this.list = res.data
          this.$clear()
        } else {
          this.$toast(res.msg)
        }
      })
    }
  },
}
</script>

<style lang="less" scoped>
.business-progress {
  height: 100%;
  overflow: auto;
}
</style>